// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2w5PX","signatureBlock":"Footer_signatureBlock__1Sxy4","signature":"Footer_signature__3T0qk"};